const topCntnt = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secCntnt = document.querySelector('#jsSecCntnt');
    let cntntWraps = secCntnt.querySelectorAll('.js-cntnt-wrap');


    cntntWraps.forEach((element, index) => {

      let imgArea = element.querySelector('.js-img-area');
      let imgBoxInner = element.querySelector('.js-img-box-inner');
      let copyArea = element.querySelector('.js-copy-area');
      let copyBox = copyArea.querySelector('.copy-box');

      let tl1 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: imgArea,
          endTrigger: secCntnt,
          start: "0% 0%",
          end: "100% 100%",
          onEnter: () => imgArea.classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => imgArea.classList.remove('is-act'),
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      })
      let tl2 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: imgArea,
          // endTrigger: secCntnt,
          start: "0% 100%",
          // end: "100% 100%",
          onEnter: () => imgBoxInner.classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => imgBoxInner.classList.remove('is-act'),
          // markers: true,
        },
      })
      let tl3 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: copyArea,
          endTrigger: secCntnt,
          start: "0% 0%",
          end: "100% 100%",
          // onEnter: () => imgArea.classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeaveBack: () => imgArea.classList.remove('is-act'),
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      })
      // let to1 = gsap.to(copyArea, {
      //   opacity: 1,
      //   ease: "none",
      //   scrollTrigger: {
      //     trigger: copyArea,
      //     start: "0% 90%",
      //     end: "0% 70%",
      //     scrub: 0,
      //     // markers: true
      //   }
      // })
      // let to2 = gsap.to(copyBox, {
      //   opacity: 0,
      //   ease: "none",
      //   scrollTrigger: {
      //     trigger: copyArea,
      //     start: "0% 200px",
      //     end: "0% 50px",
      //     scrub: 0,
      //     // markers: true
      //   }
      // })
      // let tl3 = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: copyArea,
      //     // endTrigger: secCntnt,
      //     start: "0% 80%",
      //     end: "0% 10%",
      //     onEnter: () => copyArea.classList.add('is-act'),
      //     onLeave: () => copyArea.classList.remove('is-act'),
      //     onEnterBack: () => copyArea.classList.add('is-act'),
      //     onLeaveBack: () => copyArea.classList.remove('is-act'),
      //     // markers: true,
      //   },
      // })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl1.scrollTrigger.refresh()
          tl2.scrollTrigger.refresh()
          tl3.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    });



  }
})()
export default topCntnt;